module.exports = {
    core: require('./core.spec'),
    spdk: require('./spdk.spec'),
    tv2no: require('./tv2no.spec')
};



/** WEBPACK FOOTER **
 ** ../src/config/clients/specs.js
 **/